export const ANCHOR = 'Anchor';
export const ANCHOR_LINK_LEVEL = 'AnchorLinkLevel';

